import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

/***    ANGULAR MATERIAL IMPORT    ***/
// animations

// components
import {
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    MatTableModule,
    MatCardModule,
    MatTooltipModule,
    MatPaginatorModule, MatProgressBarModule, MatDialogModule, MatExpansionModule, MatFormFieldModule,
    MatInputModule, MatSlideToggleModule, MatSortModule, MatTabsModule, MatRadioModule, MatChipsModule, MatAutocompleteModule,
    MatSelectModule, MatCheckboxModule, MatDatepickerModule,
} from '@angular/material';
/***    ANGULAR MATERIAL IMPORT    ***/

import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PipesModule} from '../pipes/pipes.module';
import {ProductDeleteConfirmDialogComponent} from './ProductDeleteConfirmDialogComponent/product-delete-confirm.dialog.component';
import {ProductsListComponent} from './ProductsListComponent/products-list.component';
import {ProductService} from '../services/product.service';
import {ProductDetailComponent} from './ProductDetailComponent/product-detail.component';
import {ProductEditComponent} from './ProductEditComponent/product-edit.component';
import {ProductContentService} from '../services/product-content.service';
import {ProductFileAddDialogComponent} from './ProductFileAddDialogComponent/product-file-add.dialog.component';
import {ProductFileService} from '../services/product-file.service';
import {AvailabilityService} from '../services/availability.service';
import {ContractsModule} from '../ContractsModule/contracts.module';
import {ProductLabelsPrintDialogComponent} from './ProductLabelsPrintDialogComponent/product-labels-print.dialog.component';
import {ProductTransferDialogComponent} from './ProductTransferDialogComponent/product-transfer.dialog.component';
import {ProductCategoryService} from '../services/product-category.service';
import {InventoryCheckDialogComponent} from './InventoryCheckDialogComponent/inventory-check.dialog.component';
import {ProductTransferService} from '../services/product-transfer.service';
import {DirectivesModule} from '../directives/directives.module';

@NgModule({
    declarations: [
        ProductsListComponent,
        ProductDeleteConfirmDialogComponent,
        ProductDetailComponent,
        ProductEditComponent,
        ProductFileAddDialogComponent,
        ProductLabelsPrintDialogComponent,
        ProductTransferDialogComponent,
        InventoryCheckDialogComponent,
    ],
    imports: [
        BrowserModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,

        // Angular Material components
        MatAutocompleteModule,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,

        ContractsModule,
        PipesModule,
        DirectivesModule,
    ],
    exports: [
    ],
    entryComponents: [
        ProductDeleteConfirmDialogComponent,
        ProductFileAddDialogComponent,
        ProductLabelsPrintDialogComponent,
        ProductTransferDialogComponent,
        InventoryCheckDialogComponent,
    ],
    providers: [
        ProductService,
        ProductTransferService,
        ProductCategoryService,
        ProductContentService,
        ProductFileService,
        AvailabilityService
    ]
})
export class ProductsModule {
}



// WEBPACK FOOTER //
// /app/src/ProductsModule/products.module.ts